import { MuiComponent } from "./type";

export const MuiSvgIcon: MuiComponent<"MuiSvgIcon"> = {
  styleOverrides: {
    root: {
      
    }
  }
};